import { MRT_ColumnDef } from 'material-react-table';
import NameCellWithImage from 'components/controls/image-cell';
import { useWorkspace } from 'hooks/useWorkspace';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { ToolTip } from 'components/controls';

export type CompanyOwnersColumns = {
    id: string;
    email: string;
    createdAt: string;
};

export const useCompanyOwnerTableColumns = (): MRT_ColumnDef<CompanyOwnersColumns>[] => {
    const { t } = useTranslation();
    const { baseWorkspaceUrl } = useWorkspace();

    return useMemo(
        () => [
            {
                accessorKey: 'fullName',
                header: t('TABLE_HEADERS.FULL_NAME'),
                size: 300,
                Cell: ({ cell }) => {
                    const path = `${baseWorkspaceUrl}/company-owner/${cell.row.original.id}`;

                    return (
                        <ToolTip
                            disableHoverListener={cell.row.original['fullName'].length < 30}
                            title={cell.getValue<string>()}
                            placement="top-end"
                        >
                            <NameCellWithImage cell={cell} isLink path={path} target="_self" />
                        </ToolTip>
                    );
                },
                enableColumnActions: false,
                enableSorting: false,
            },
            {
                accessorKey: 'email',
                header: t('TABLE_HEADERS.EMAIL'),
                size: 250,
                enableSorting: false,
                enableColumnActions: false,
                enableColumnFilter: false,
            },
            {
                accessorKey: 'companyName',
                header: t('TABLE_HEADERS.COMPANY'),
                size: 150,
                enableSorting: false,
                enableColumnActions: false,
                enableColumnFilter: false,
            },
            {
                accessorKey: 'createdAt',
                header: t('TABLE_HEADERS.CREATION_DATE'),
                size: 100,
                enableColumnActions: false,
                enableColumnFilter: false,
            },
        ],
        [t, baseWorkspaceUrl],
    );
};
